exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.action-block{pointer-events:none\n}\n.goodsDetail{word-wrap:break-word\n}\n.goodsDetail img{max-width:100%!important;vertical-align:bottom;float:left\n}", "", {"version":3,"sources":["/home/ylp/ylp-leadmall-c/src/module/goods/detail/page.vue"],"names":[],"mappings":";AACA,cAAc,mBAAmB;CAChC;AACD,aAAa,oBAAoB;CAChC;AACD,iBAAiB,yBAAyB,sBAAsB,UAAU;CACzE","file":"page.vue","sourcesContent":["\n.action-block{pointer-events:none\n}\n.goodsDetail{word-wrap:break-word\n}\n.goodsDetail img{max-width:100%!important;vertical-align:bottom;float:left\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67bafe64","scoped":false,"hasInlineConfig":false}!./node_modules/vux-loader/src/after-less-loader.js!./node_modules/less-loader?{"sourceMap":true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/module/goods/detail/page.vue
// module id = 23LL
// module chunks = 1